import { useEffect, useState } from "react";
import formDate from "../Components/Structure/utils/formDate.js";
import api from "../api/axios.js"; 
export function useEnzymeStructureRemote(enzymeMarts) {
  const [available, setAvailable] = useState([]);
  const [selected, setSelected] = useState(null);
  const [hasStructure, setHasStructure] = useState(false);

  useEffect(() => {
    let cancelled = false;

    setAvailable([]);
    setSelected(null);
    setHasStructure(false);

    if (!enzymeMarts) return;

    // The structure files themselves are deliberately NOT pre-fetched here: the
    // list is built straight from the metadata, and a file that turns out to be
    // missing surfaces as an error in ProteinViewer when its button is selected.
    // Validating up front meant downloading every structure serially before the
    // section could appear at all.
    (async () => {
      try {
        const resp = await api.get("/searchstructures", {
          params: { marts: enzymeMarts }
        });
        if (cancelled) return;
        const rows = (resp.data?.structures || []).filter(r => r?.file_name);
        const out = rows.map(r => {
            const ext = (r.file_name.match(/\.([a-z0-9]+)$/i)?.[1] || "").toLowerCase();
            const format = ext === "cif" || ext === "mmcif" ? "cif" : "pdb";
            const baseName = r.file_name.replace(/\.(pdb|cif|mmcif|ent)$/i, "");
            const m = (r.method || '').toLowerCase();
            const isPred = m === 'alphafold' || m === 'esmfold';
            return {
              id: r.structure_id,
              pdb_id: r.pdb_id ?? "Not available",
              path: `/structurefile/${baseName}`,
              format,
              file_name: r.file_name,
              method: r.method ?? "Not available",
              form: r.form ?? null,
              source_name: r.source_name ?? null,
              source_description: r.source_description ?? null,
              type: isPred ? "Predicted" : "Experimental",
              resolution: !isPred ? (r.resolution ?? "Not available") : undefined,
              date: formDate(r.date) ?? "Not available",
              ligands: r.ligands || [],
              label: isPred
                ? (r.method || "Predicted")
                : (r.method ? `Experimental • ${r.method}` : `Experimental`)
            };
        });
        setAvailable(out);
        setSelected(out[0] ?? null);
        setHasStructure(out.length > 0);
      } catch (e) {
        if (!cancelled) {
          console.error("load structures error", e);
          setAvailable([]);
          setSelected(null);
          setHasStructure(false);
        }
      }
    })();

    return () => { cancelled = true; };
  }, [enzymeMarts]);

  return {
    availableStructures: available,
    selectedStructure: selected,
    setSelectedStructure: setSelected,
    hasStructure,
    setHasStructure,
  };
}
